// extracted by mini-css-extract-plugin
export default {"inputContainer":"TodoInput_inputContainer__Ip5AD","todoInput":"TodoInput_todoInput__4+hoI","addTodoButton":"TodoInput_addTodoButton__xivPi","error":"TodoInput_error__aFrWC"};